import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionLogicBoxContentContainer = styled.div.withConfig({
  displayName: "ConditionLogicBox__ConditionLogicBoxContentContainer",
  componentId: "j2pdgq-0"
})(["height:22px;", ""], ({
  hideOperator
}) => hideOperator && 'visibility: hidden;');
const ConditionLogicBox = ({
  logicOperator,
  hideOperator = false
}) => {
  let logicBoxContent = null;
  if (logicOperator === LogicGroupNames.AND) {
    logicBoxContent = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.logicOperator.and"
    });
  } else if (logicOperator === LogicGroupNames.OR) {
    logicBoxContent = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.logicOperator.or"
    });
  }
  return /*#__PURE__*/_jsx(ConditionLogicBoxContentContainer, {
    hideOperator: hideOperator,
    children: /*#__PURE__*/_jsx("strong", {
      children: logicBoxContent
    })
  });
};
export default ConditionLogicBox;